import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandleInterceptorService {

  constructor(private router: Router, private modalController: ModalController) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.dismissAllModals();
          this.router.navigate(['/login'], { queryParams: { expired: true } });
        }
        return throwError(error);
      })
    );
  }

  private async dismissAllModals() {
    await this.modalController.dismiss();
  }

}
